import Decimal from 'decimal.js'

const NumberUtil = {
  round: (value: number, how: number) => {
    const dec = new Decimal(value)
    return Number(dec.toFixed(how, 4))
  },
}

export default NumberUtil
